import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const CalendarStart = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="17"
        height="19"
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.75 0.975342C5.16421 0.975342 5.5 1.31113 5.5 1.72534V2.97534H10.5V1.72534C10.5 1.31113 10.8358 0.975342 11.25 0.975342C11.6642 0.975342 12 1.31113 12 1.72534V2.97534H12.75C14.2695 2.97534 15.5 4.20737 15.5 5.72534V10.2523C15.5 10.6666 15.1642 11.0023 14.75 11.0023C14.3358 11.0023 14 10.6666 14 10.2523V7.97534H2V14.2253C2 14.9154 2.55946 15.4753 3.25 15.4753H7.984C8.39821 15.4753 8.734 15.8111 8.734 16.2253C8.734 16.6396 8.39821 16.9753 7.984 16.9753H3.25C1.73054 16.9753 0.5 15.7433 0.5 14.2253V5.72534C0.5 4.20737 1.73054 2.97534 3.25 2.97534H4V1.72534C4 1.31113 4.33579 0.975342 4.75 0.975342ZM12.75 4.47534C13.4405 4.47534 14 5.03531 14 5.72534V6.47534H2V5.72534C2 5.03531 2.55946 4.47534 3.25 4.47534H12.75Z"
          fill="#ADACA8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9208 11.8899C13.7938 11.6358 13.5341 11.4753 13.25 11.4753C12.9659 11.4753 12.7062 11.6358 12.5792 11.8899L11.691 13.6663L9.91459 14.5545C9.6605 14.6816 9.5 14.9413 9.5 15.2253C9.5 15.5094 9.6605 15.7691 9.91459 15.8962L11.691 16.7844L12.5792 18.5608C12.7062 18.8148 12.9659 18.9753 13.25 18.9753C13.5341 18.9753 13.7938 18.8148 13.9208 18.5608L14.809 16.7844L16.5854 15.8962C16.8395 15.7691 17 15.5094 17 15.2253C17 14.9413 16.8395 14.6816 16.5854 14.5545L14.809 13.6663L13.9208 11.8899ZM12.9208 14.5608L13.25 13.9024L13.5792 14.5608C13.6518 14.7059 13.7694 14.8236 13.9146 14.8962L14.5729 15.2253L13.9146 15.5545C13.7694 15.6271 13.6518 15.7448 13.5792 15.8899L13.25 16.5483L12.9208 15.8899C12.8482 15.7448 12.7306 15.6271 12.5854 15.5545L11.9271 15.2253L12.5854 14.8962C12.7306 14.8236 12.8482 14.7059 12.9208 14.5608Z"
          fill="#ADACA8"
        />
      </svg>
    </SvgIcon>
  )
}

export default CalendarStart
